import Axios from "axios";
import { API_URL } from "../config";

const usePublicAxios = () => {
  // * API key for public endpoints
  const API_KEY = "tUx5/zbRw5sToHjOkWwP0ZXrfNulVcPG+XOZmVD54CY=";

  // * Create axios instance with API key authentication
  const axios = Axios.create({
    baseURL: API_URL,
    headers: {
      common: {
        "x-api-key": API_KEY,
      },
    },
  });

  return axios;
};

export default usePublicAxios;

